<div class="game-screen">
  <app-score (menuState)="showMenu($event)"></app-score>

  <div class="game-screen__below">
    <app-grid></app-grid>

    <mat-grid-list cols="3" rowHeight="3:1">
      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <ng-template appPiece1></ng-template>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <ng-template appPiece2></ng-template>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <ng-template appPiece3></ng-template>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <app-end-game-menu
    *ngIf="displayMenu"
    [code]="messageMenuCode"
    [newBestScore]="newBestScore"
    (menuState)="showMenu($event)"
    (settingsState)="showSettings($event)"
  ></app-end-game-menu>

  <app-settings
    *ngIf="displaySettings"
    (settingsState)="showSettings($event)"
  ></app-settings>
</div>
